import { default as indexhn0RloS2RrMeta } from "/builds/masterbranch1/smg-callcentre/smg-callcentre-admin/pages/admin/index.vue?macro=true";
import { default as indexJySlhoPB9aMeta } from "/builds/masterbranch1/smg-callcentre/smg-callcentre-admin/pages/auth0/callback/index.vue?macro=true";
import { default as index7oQHa0EvlgMeta } from "/builds/masterbranch1/smg-callcentre/smg-callcentre-admin/pages/auth0/logout/index.vue?macro=true";
import { default as indexXM5yuweI8mMeta } from "/builds/masterbranch1/smg-callcentre/smg-callcentre-admin/pages/index.vue?macro=true";
import { default as indexpIgzb8FZRiMeta } from "/builds/masterbranch1/smg-callcentre/smg-callcentre-admin/pages/login/index.vue?macro=true";
export default [
  {
    name: indexhn0RloS2RrMeta?.name ?? "admin",
    path: indexhn0RloS2RrMeta?.path ?? "/admin",
    meta: indexhn0RloS2RrMeta || {},
    alias: indexhn0RloS2RrMeta?.alias || [],
    redirect: indexhn0RloS2RrMeta?.redirect || undefined,
    component: () => import("/builds/masterbranch1/smg-callcentre/smg-callcentre-admin/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: indexJySlhoPB9aMeta?.name ?? "auth0-callback",
    path: indexJySlhoPB9aMeta?.path ?? "/auth0/callback",
    meta: indexJySlhoPB9aMeta || {},
    alias: indexJySlhoPB9aMeta?.alias || [],
    redirect: indexJySlhoPB9aMeta?.redirect || undefined,
    component: () => import("/builds/masterbranch1/smg-callcentre/smg-callcentre-admin/pages/auth0/callback/index.vue").then(m => m.default || m)
  },
  {
    name: index7oQHa0EvlgMeta?.name ?? "auth0-logout",
    path: index7oQHa0EvlgMeta?.path ?? "/auth0/logout",
    meta: index7oQHa0EvlgMeta || {},
    alias: index7oQHa0EvlgMeta?.alias || [],
    redirect: index7oQHa0EvlgMeta?.redirect || undefined,
    component: () => import("/builds/masterbranch1/smg-callcentre/smg-callcentre-admin/pages/auth0/logout/index.vue").then(m => m.default || m)
  },
  {
    name: indexXM5yuweI8mMeta?.name ?? "index",
    path: indexXM5yuweI8mMeta?.path ?? "/",
    meta: indexXM5yuweI8mMeta || {},
    alias: indexXM5yuweI8mMeta?.alias || [],
    redirect: indexXM5yuweI8mMeta?.redirect || undefined,
    component: () => import("/builds/masterbranch1/smg-callcentre/smg-callcentre-admin/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexpIgzb8FZRiMeta?.name ?? "login",
    path: indexpIgzb8FZRiMeta?.path ?? "/login",
    meta: indexpIgzb8FZRiMeta || {},
    alias: indexpIgzb8FZRiMeta?.alias || [],
    redirect: indexpIgzb8FZRiMeta?.redirect || undefined,
    component: () => import("/builds/masterbranch1/smg-callcentre/smg-callcentre-admin/pages/login/index.vue").then(m => m.default || m)
  }
]